import axios from 'axios';
import router from '@/router/index'
import {Toast} from "vant";
import api from '@/utils/api'
import {jumpWxAuth,configApi,isWeixin} from '@/utils/common'

axios.defaults.timeout = 20000;
axios.defaults.baseURL ='';


//http request 拦截器
axios.interceptors.request.use(
  config => {
    config.data = config.data;
    config.headers = {
      'Content-Type':'application/json'
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    console.log("msg:  " + response.data.msg)
    // if(response.data.sta ==-500||response.data.msg.indexOf('access_token')){
      if(response.data.sta ==-500){
      localStorage.removeItem("token");
      // 只有在微信环境中才跳转微信授权
      if (isWeixin()) {
        jumpWxAuth();
      }
      // jumpWxAuth().then(()=>{
      //   configApi();
      //   router.push({
      //     path: "/errorPage"
      //   });
      // });
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

 function get(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(api.baseUrl + url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

  function post(url,data = {}){
   return new Promise((resolve,reject) => {
     axios.post(api.baseUrl + url,data)
          .then(response => {
            resolve(response.data);
          },err => {
            reject(err)
          })
   })
 }


export default{
	get,
	post
}



// WEBPACK FOOTER //
// ./src/utils/request.js